import json from './cotton.json';
import $ from 'jquery';
import lottie from 'lottie-web';

import '../../../images/animations/cotton/img_10.png';
import '../../../images/animations/cotton/img_11.png';
import '../../../images/animations/cotton/img_12.png';
import '../../../images/animations/cotton/img_13.png';

var options = {
  container: $('.cotton')[0],
  renderer: 'svg',
  loop: true,
  autoplay: true,
  animationData: json,
  assetsPath: 'src/images/animations/cotton/'
};

lottie.loadAnimation(options);
